import { get, isEmpty, isEqual, head } from 'lodash';
import { getPaymentIdToAuthorise, getToAuthorise } from '../payments/builders';
import { getFxRateForAPayment, getChargeForAPayment } from './builders';
import { fxRatesType } from '../../config';

export const getRatesError = (state) => get(state, 'rates.error', undefined);
export const getRates = (state) => get(state, 'rates.fxRates', {});

export const isRatesApiInProgress = (state) => get(state, 'rates.ratesApiInProgress', 0) > 0;

export const getExchangeRate = (state) =>
	get(getFxRateForAPayment(getRates(state), getPaymentIdToAuthorise(state)), 'fx.rate');

export const getPaymentAmounts = (state) =>
	get(getFxRateForAPayment(getRates(state), getPaymentIdToAuthorise(state)), 'details.0.payment_amount', []);

export const getFxChargeAmount = (state) => {
	const paymentIdToAuthorise = getPaymentIdToAuthorise(state);
	const fxRateForPayment = getFxRateForAPayment(getRates(state), paymentIdToAuthorise);

	const chargeAmount = getChargeForAPayment(fxRateForPayment, paymentIdToAuthorise);
	return chargeAmount;
};
export const getNewSubmissionAndSettlementDates = (state) => {
	const rates = getRates(state);
	const ratesForPayment = get(rates, Object.keys(rates)[0], {});
	const ratesDetails = get(ratesForPayment, 'details[0]', {});
	if (!isEmpty(ratesDetails)) {
		return {
			newSettlementDate: ratesDetails.value_date,
			newSubmissionDate: ratesDetails.submission_date,
			isPaymentDatesUpdated: ratesDetails.value_date_updated,
			isCurrentDated: isEqual(ratesForPayment.current_date, ratesDetails.submission_date),
		};
	}
	return {};
};
export const isPaymentAuthoriseAllowed = (state) => {
	const rates = getRates(state);
	const ratesForPayment = get(rates, Object.keys(rates)[0], {});
	const ratesDetails = get(ratesForPayment, 'details[0]', {});
	if (!isEmpty(ratesDetails)) {
		const isCurrentDated = isEqual(ratesForPayment.current_date, ratesDetails.submission_date);

		return (
			isCurrentDated ||
			(!isCurrentDated &&
				!ratesForPayment.indicative &&
				ratesDetails.value_date_type !== 'SPOT' &&
				ratesDetails.payment_method !== 'SEPA')
		);
	}
	return false;
};

export const isPaymentDateChanged = ({ submission_date, value_date } = {}, { newSubmissionDate, newSettlementDate }) =>
	!isEqual(newSubmissionDate, submission_date) || !isEqual(value_date, newSettlementDate);

export const getNewSubmissionAndSettlementDatesForRatesApi = (
	isNewPaymentDate,
	{ newSubmissionDate, newSettlementDate }
) => {
	if (isNewPaymentDate) {
		return {
			new_submission_date: newSubmissionDate,
			new_settlement_date: newSettlementDate,
		};
	}
	return {};
};

export const getRatesRequestForAuthorisation = (state) => {
	const rates = getRates(state);
	const { final_approval, payments = [] } = getToAuthorise(state);
	const newSubmssionAndSettlementDates = getNewSubmissionAndSettlementDates(state);
	const isNewPaymentDate = isPaymentDateChanged(head(payments), newSubmssionAndSettlementDates);

	if (!isEmpty(rates)) {
		const rateIds = Object.keys(rates);
		return {
			indicative_rate: !final_approval,
			...getNewSubmissionAndSettlementDatesForRatesApi(isNewPaymentDate, newSubmssionAndSettlementDates),
			value_date_type: get(rates[rateIds[0]], 'details.0.value_date_type'),
			rate: rateIds.map((paymentId) => {
				const rate = rates[paymentId];
				return {
					pei_bulk_id: get(rate, 'pei_bulk_id'),
					pei_id: get(rate, 'details.0.pei_id'),
					payment_uuid: paymentId,
				};
			}),
		};
	}
	return {};
};

export const isPreBookedPayment = (state) => {
	const toAuthorise = getToAuthorise(state);
	return get(toAuthorise, 'ift.indicative_fx.type') === fxRatesType.PRE_BOOKED_RATE;
};

export const isSameCurrency = (state) => {
	const { ift = null } = getToAuthorise(state);
	return ift ? ift.creditor_currency === ift.debtor_currency : false;
};

export const showLiveRate = (state) => {
	const { ift = null } = getToAuthorise(state);
	const isSameCurrencyPayment = ift ? ift.creditor_currency === ift.debtor_currency : false;
	return isSameCurrencyPayment
		? false
		: !!get(getFxRateForAPayment(getRates(state), getPaymentIdToAuthorise(state)), 'fx.validity_duration');
};
